import BigNumber from 'bignumber.js'

import { BigNumber as BigNumber_, Schema as Schema_ } from '@blade/std-lib'

import type { Equivalence } from '@blade/std-lib'
import type { InstantTradeSellButtonDto } from '@root/shared/api/UserApi'

export const Schema = Schema_.Struct({
  key: Schema_.String,
  percent: BigNumber_.FromString,
})
export interface InstantTradeSellButton
  extends Schema_.Schema.Type<typeof Schema> {}

export const fromDto = (
  dto: InstantTradeSellButtonDto,
): InstantTradeSellButton => {
  return {
    key: dto.key,
    percent: BigNumber(dto.percent),
  }
}

export const eq: Equivalence.Equivalence<InstantTradeSellButton> = (a, b) => {
  return a.key === b.key && a.percent.eq(b.percent)
}
